<template>
  <v-card>
    <v-card-title class="primary white--text">
      <span class="headline"> {{ $t('editName') }} </span>
    </v-card-title>
    <v-card-text class="pt-6">
      <v-text-field
        ref="nameInput"
        v-model="name"
        :label="$t('name')"
        :maxLength="maxNameLength"
        :rules="nameRules"
        :counter="maxNameLength"
        @keydown.enter="confirmIfValid"/>
    </v-card-text>
    <v-card-actions class="pb-4 px-0 mt-4">
      <v-row justify="space-between">
        <v-col cols="auto"> <v-btn text outlined color="secondary" @click="editCanceled">{{ $t('cancel') }}</v-btn> </v-col>
        <v-col cols="auto"> <v-btn color="primary" :disabled="!isValid" @click="editConfirmed">{{ $t('confirm') }}</v-btn> </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import fieldRules from '@/utils/rules'

const MAX_NAME_LENGTH = 32

export default {
  name: 'RateSheetDefinitionNameEditor',

  props: {
    propName: {
      type: String,
      required: true
    }
  },

  data: () => ({
    name: '',
    maxNameLength: MAX_NAME_LENGTH,
    rules: fieldRules.rules
  }),

  mounted () {
    this.initialize()
  },

  computed: {
    nameRules () {
      return [this.rules.required]
    },

    isValid () {
      return !!this.name &&
        this.name.length <= MAX_NAME_LENGTH &&
        this.name.length > 0 && this.name !== this.propName
    }
  },

  methods: {
    initialize () {
      this.name = this.propName
      this.$nextTick(() => {
        this.$refs.nameInput.focus()
      })
    },

    editCanceled () {
      this.$emit('edit-canceled')
    },

    editConfirmed () {
      this.$emit('edit-confirmed', this.name)
    },

    confirmIfValid () {
      if (this.isValid) {
        this.editConfirmed()
      }
    }
  }
}
</script>
